import React from 'react';
import { motion } from 'framer-motion';
import Button from '../ui/Button';
import LazyImage from '../ui/LazyImage';
export default function HeroSection() {
  return <section className="bg-gradient-to-br from-primary via-primary-dark to-primary text-white py-20 md:py-24 lg:py-32 pt-24 md:pt-28" data-id="element-206">
      <div className="container mx-auto px-4" data-id="element-207">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-208">
          <motion.div className="md:w-1/2 w-full" initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-209">
            <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-serif font-bold mb-6 leading-tight" data-id="element-210">
              <span className="block mb-2" data-id="element-211">Medico-Legal Psychiatry</span>
              <span className="block text-2xl md:text-3xl lg:text-4xl text-secondary" data-id="element-212">
                Expert Witness Psychiatric Services UK
              </span>
            </h1>
            <p className="text-lg md:text-xl mb-8 leading-relaxed opacity-90" data-id="element-213">
              Trusted independent psychiatric assessments and expert witness
              reports for solicitors, barristers, and courts across the UK.
              Providing specialist psychiatric evaluations for legal
              proceedings.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-214">
              <Button variant="secondary" size="lg" href="/contact" pulse data-id="element-215">
                Instruct Dr. Syed
              </Button>
              <Button variant="transparent" size="lg" href="/services" data-id="element-216">
                Our Services
              </Button>
            </div>
          </motion.div>
          <motion.div className="md:w-1/2 w-full flex justify-center" initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-217">
            <div className="relative group" data-id="element-218">
              <div className="absolute -inset-1 bg-gradient-to-r from-secondary to-secondary-light rounded-lg blur opacity-25 group-hover:opacity-40 transition duration-300" data-id="element-219"></div>
              <LazyImage src="https://uploadthingy.s3.us-west-1.amazonaws.com/u9Nr778koLscH9uY6kZjEn/01._Hero_Image.png" alt="Dr. Imtiaz Syed – GMC-registered Psychiatrist and accredited medico-legal expert witness" className="relative rounded-lg shadow-2xl max-w-full h-auto w-full md:w-3/4 transform transition-transform group-hover:scale-105" data-id="element-220" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}